import {buildRequest, httpGet, httpPost} from "./http";

const deploymentsUrl = window.env.BACKEND_API_URL + "/deployments";
const availabilitiesUrl = window.env.BACKEND_API_URL + "/availabilities";

// Filter type refers to the conditionals in the DeploymentController:index route.
// 'include_availability' is used for the BookingMap.
// 'only_available' is used for the DeploymentSelect.
const getDeployments = async (startedAt, endedAt, filterType, page, pageSize, signal) => {
    startedAt = encodeURIComponent(startedAt);
    filterType = encodeURIComponent(filterType)
    page = encodeURIComponent(page);
    pageSize = encodeURIComponent(pageSize);
    let indexUrl = `${deploymentsUrl}?page=${page}&per_page=${pageSize}&filter_type=${filterType}`;

    indexUrl += `&started_at=${startedAt}`;
    if (endedAt) {
        endedAt = encodeURIComponent(endedAt);
        indexUrl += `&ended_at=${endedAt}`;
    }

    return await httpGet(indexUrl, signal);
};

const getDeployment = async (deploymentID, signal) => {
    let singleDeploymentUrl = `${deploymentsUrl}/${deploymentID}`;

    return httpGet(singleDeploymentUrl, signal);
};

const createDeployment = async ({deployableID, deployableType, locationID, startedAt, endedAt}, signal) => {
    let body = {
        'deployable_id': deployableID,
        'deployable_type': deployableType,
        'location_id': locationID,
        'started_at': startedAt,
    };

    // Optional parameter
    if (endedAt) {
        body['ended_at'] = endedAt;
    }

    return httpPost(deploymentsUrl, body, signal);
};

const swapDeployments = async ({deployableAID, deployableBID, newStartedAt, newEndedAt, deployableType}, signal) => {
    const swapDeploymentsUrl =
        `${deploymentsUrl}/swap_deployments`;

    let body = {
        'deployable_a_id': deployableAID,
        'deployable_b_id': deployableBID,
        'deployable_type': deployableType,
        'started_at': newStartedAt,
    };

    if (newEndedAt) {
        body['ended_at'] = newEndedAt;
    }
    return httpPost(swapDeploymentsUrl, body, signal);
};

const getIsDeploymentAvailable = async (deploymentID, startTime, endTime, signal) => {
    startTime = encodeURIComponent(startTime.format('YYYY-MM-DD HH:mm:ssZZ'));
    endTime = encodeURIComponent(endTime.format('YYYY-MM-DD HH:mm:ssZZ'));
    const isAvailableURL = `${deploymentsUrl}/${deploymentID}/is_available?started_at=${startTime}&ended_at=${endTime}`;

    return await httpGet(isAvailableURL, signal);
}

const getAvailabilityByDeployment = async (deploymentID, signal) => {
    let availabilityUrl = `${deploymentsUrl}/${deploymentID}/availability`;
    let response;

    try {
        response = await buildRequest(
            availabilityUrl,
            {
                method: 'GET'
            },
            '*',
            signal
        );
        return response;
    } catch (error) {
        throw error;
    }
};

const getBookingsByDeployment = async (deploymentID, signal) => {
    const deploymentBookingsUrl = `${deploymentsUrl}/${deploymentID}/bookings`;

    return await httpGet(deploymentBookingsUrl, signal);
};

const getDeploymentsByTime = async (startedAt, endedAt, page, pageSize, signal) => {
    startedAt = encodeURIComponent(startedAt);
    page = encodeURIComponent(page);
    pageSize = encodeURIComponent(pageSize);
    let requestUrl = `${deploymentsUrl}/time?page=${page}&per_page=${pageSize}`;

    requestUrl += `&started_at=${startedAt}`;
    if (endedAt) {
        endedAt = encodeURIComponent(endedAt);
        requestUrl += `&ended_at=${endedAt}`;
    }

    return await httpGet(requestUrl, signal);
};

// This route is used by the AvailabilityController::getDeploymentBookings.
const getDeploymentBookings = async ({deploymentIDs, bookingStatus = 'CONFIRMED', pageSize, pageNumber, date}, signal) => {
    date = encodeURIComponent(date);
    const deploymentBookingsUrl =
        `${availabilitiesUrl}/deployment_bookings?deployments=${deploymentIDs}&booking_state=${bookingStatus}&per_page=${pageSize}&page=${pageNumber}&date=${date}`;

    return await httpGet(deploymentBookingsUrl, signal);
};

export {
    getDeployments,
    getDeployment,
    createDeployment,
    swapDeployments,
    getAvailabilityByDeployment,
    getIsDeploymentAvailable,
    getBookingsByDeployment,
    getDeploymentBookings,
    getDeploymentsByTime,
};
